// extracted by mini-css-extract-plugin
export default {"container":"ZIuau4QDnrmx3q54Opk9","title":"VD0gEJGvFdveWOgupGOr"};